import { render } from "./TagInput.vue?vue&type=template&id=2812c5bb"
import script from "./TagInput.vue?vue&type=script&lang=js"
export * from "./TagInput.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/poll/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/TagInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2812c5bb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2812c5bb', __exports__)) {
    console.log('reload')
    api.reload('2812c5bb', __exports__)
  }
  
  module.hot.accept("./TagInput.vue?vue&type=template&id=2812c5bb", () => {
    console.log('re-render')
    api.rerender('2812c5bb', render)
  })

}


export default __exports__